module.exports = __webpack_public_path__ + "media/images/general/arrow_tri-fe17a5aaf31668239d5195d69bec95b6.svg";